module.exports = __webpack_public_path__ + "static/media/TCC.3009bf9f.jpg";